export default __webpack_public_path__ + "static/media/Treadlight Boots.e6b86aed.jpg";